const list = {
  // =================================================================================================================
  components() {
    return [
      {
        'component': 'search-select-field', label: '부서명', value: 'field', query: {'f_id': 'fieldId', 'f_name': 'fieldName'},
        options: {
          default: {fieldId: '', fieldName: ''},
          gridTemplateColumns: '100px auto',
        }
      },
      {'component': 'empty-space'},
      {
        'component': 'search-select-company-tree', label: '1차 분류', value: 'companyTree', query: {'c0': 'company0', 'c1': 'company1', 'c2': 'company2'},
        options: {
          default: { company0: null, company1: null, company2: null },
          gridTemplateColumns: '100px auto',
        }
      },
      {'component': 'empty-space'},
      {
        'component': 'search-column-keyword',
        label: '검색조건',
        value: 'column',
        query: {'ck_t': 'head', 'ck_k': 'keyword'},
        options: {
          hiddenList: ['현보직일', '총 교육이수 시간', '퇴임일', '부서명'],
          gridTemplateColumns: '100px auto',
        }
      },
    ]
  },
  getConditions: (nav) => {

    const conditions = [];
    const search = nav.value;

    if (search.field.fieldName) {
      conditions.push({key: 'body.fieldNames[%]', operator: 'LIKE', value: search.field.fieldName})
    }

    if (search.companyTree) {
      search.company0 = search.companyTree.company0
      search.company1 = search.companyTree.company1
      search.company2 = search.companyTree.company2
    }

    //  검색조건
    const heads = list.getHead().map(e => {return {[e.name] : e.key}});
    // 배열의 객체들을 하나의 객체로 합치기
    const types = Object.assign({}, ...heads);
    if (search.column && search.column.keyword) {
      if (search.column.head === '성명') {
        conditions.push({key: types[search.column.head], operator: 'LIKE', value: search.column.keyword})
      } else {
        conditions.push({key: types[search.column.head], operator: 'LIKE', value: `%${search.column.keyword}%`})
      }
    }
    return conditions;
  },


  // =================================================================================================================
  getHead: () => {
    return [
      { name: "부서명", key: "body.stdInfo.fieldNames" },
      { name: "ID(사번)", key: "body.employee_id" },
      { name: "팀명", key: "body.targetCompany" },
      { name: "구분", key: "body.job_category" },
      { name: "직종", key: "body.employment_type" },
      { name: "직급", key: "body.job_title" },
      { name: "성명", key: "full_name" },
      { name: "최종 입사일", key: "body.hire_date" },
      { name: "현보직일", key: "body.current_position_date" },
      { name: "연락처", key: "body.contact_number" },
      { name: "총 교육이수 시간", key: "body.inputC_2" },
      { name: "퇴임일", key: "body.retirement_date" },
    ];
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
        case 0: {
          // 사업장명
          const fieldNames = !func.getContent(value).fieldNames ? func.getContent(value).field_names : func.getContent(value).fieldNames;
          if (fieldNames && fieldNames.length === 1) {
            return fieldNames.join(", ");
          } else if (fieldNames && fieldNames.length > 1) {
            // 만약 두번째 아이템이 4글자 이하면 첫번째와 두번째 아이템을 쉼표로 붙여서 반환한다
            if (fieldNames[1].length <= 4) {
              return `${fieldNames[0]}, ${fieldNames[1]}`;
            } else {
              return `${fieldNames[0]}, ${fieldNames[1].substring(0, 4)}...`;
            }
          } else {
            return "-";
          }
        }
        case 1:
          return func.getContent(value).employee_id; // 사번
        case 2:
          return func.getContent(value).targetCompany; // 부서
        case 3:
          return func.getContent(value).job_category; // 구분
        case 4:
          return func.getContent(value).employment_type; // 직종
        case 5:
          return func.getContent(value).job_title; // 직급
        case 6:
          return func.getContent(value).enc.full_name; // 성명
        case 7:
          return func.getContent(value).hire_date; // 최종 입사일
        case 8:
          return func.getContent(value).current_position_date; // 현보직일
        case 9:
          return func.getContent(value).enc.contact_number; // 연락처
        case 10: {
          // 총 교육이수 시간
          if (typeof value.total_education_hours === "undefined") return "0시간 0분";
          const totalEducationHours = value.total_education_hours;

          // "H시간 M분" 형식으로 변환한다.
          // 데이터는 3.5 와 같은 형식으로 저장되어 있으며 "3시간 30분" 으로 변환되야 한다.
          const hours = Math.floor(totalEducationHours);
          const minutes = Math.round((totalEducationHours - hours) * 60);
          return `${hours}시간 ${minutes}분`;
        }
        case 11:
          return func.getContent(value).retirement_date; // 퇴임일
      }
    } catch (e) {
      /*ignore*/
    }
    return "";
  },
  getSearchKeyValue: (nav) => {},
  getSearchKeyword: (nav) => {},
};
export default list;
